<ng-container *ngIf="shouldShowErrors()">
  <img *ngIf="!noImage" src="/assets/icons/alert-24-traingle-red.svg" />
  <span class="form-row-error">{{ error }}</span>
</ng-container>
<ng-container *ngIf="shouldShowAccepted() && !noImage">
  <i class="ai ai-tick"></i>
</ng-container>
